import React, { useState, useEffect } from 'react';
import './r1.css';
import logo from "../assets/images/White_logo.png";
import logo2 from "../assets/images/logo2.png";
import white from "../assets/images/White_logo.png";
import heroImg from '../assets/images/hero_modular_building_1772708548531.jpg';
import workerImg from '../assets/images/worker_assembly_1772708573403.jpg';
import bathroomImg from '../assets/images/bathroom_pod_frame_1772708611400.jpg';

import hospitalImg from '../assets/images/modern_hospital_exterior_1772708643819.jpg';

import financeImg from '../assets/images/R-ONE-WEBSITE-Banner-3.jpg';

import craneVideo from "../assets/images/videos/A.mp4";
import locationImg from '../assets/images/hyderabad_financial_district_premium.jpg';

import formImg from '../assets/images/R-ONE-WEBSITE-Banner-4.jpg';

import urgencyBg from '../assets/images/luxury_office_urgency_bg.jpg';
import BASE_URL from '../config/api';


// import { BASE_URL } from "../config/api";

import { FaBuilding, FaHandHoldingUsd, FaCreditCard, FaChartLine } from "react-icons/fa";
import { FaMapMarkerAlt, FaRocket, FaLaptopCode, FaRoad, FaPlaneDeparture } from "react-icons/fa";


export default function ModularConstruction() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        budget: ''
    });
    const [isDownloadPending, setIsDownloadPending] = useState(false);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                }
            });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDownloadClick = (e) => {
        if (e) e.preventDefault();
        setIsDownloadPending(true);
        setShowPopup(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.phone || !formData.budget) {
            alert("Please fill in all required fields.");
            return;
        }

        try {
            const response = await fetch(`${BASE_URL}/ready`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                console.error("Server Error:", data);
                alert(`Server Error ${response.status}: ${data.message || JSON.stringify(data)}`);
                return;
            }
            if (data.success)
            {
           alert("Form submitted successfully!");
           const link = document.createElement('a');
           link.href = '/Diamond-Tower-Floor-Plans-Brochure-2.pdf';
           link.download = 'Diamond-Tower-Floor-Plans-Brochure-2.pdf';
           document.body.appendChild(link);
           link.click();
           document.body.removeChild(link);
           setIsDownloadPending(false);
           setFormData({ name: "", email: "", phone: "", budget: "" });
           setShowPopup(false);
          }
          else
          {
          alert(data.message || "Submission failed. Please try again.");
          }

          

        } catch (error) {
            console.error("Full Error:", error);
            alert(`Error: ${error.message}`);
        }
    };

    const handlePopup = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone) {
        alert("Please fill in all required fields.");
        return;
    }

    try {
        const response = await fetch(`${BASE_URL}/popup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(formData)
        });

        const data = await response.json();

        if (!response.ok) {
            console.error("Server Error:", data);
            alert(`Server Error ${response.status}: ${data.message || JSON.stringify(data)}`);
            return;
        }

        // ✅ FIXED HERE
        if (data.success) {
            alert("Form submitted successfully!");

           
                const link = document.createElement('a');
                link.href = '/Diamond-Tower-Floor-Plans-Brochure-2.pdf';
                link.setAttribute('download', 'Diamond-Tower-Floor-Plans-Brochure-2.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setIsDownloadPending(false);
           

            setFormData({ name: "", phone: "" });
            setShowPopup(false);
        } else {
            alert(data.message || "Submission failed. Please try again.");
        }

    } catch (error) {
        console.error("Full Error:", error);
        alert(`Error: ${error.message}`);
    }
};
    //     const handlePopup = async (e) => {
    //     e.preventDefault();

    //     if (!formData.name || !formData.phone ) {
    //         alert("Please fill in all required fields.");
    //         return;
    //     }

    //     try {
    //         const response = await fetch(`${BASE_URL}/popup`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Accept": "application/json"
    //             },
    //             body: JSON.stringify(formData)
    //         });

    //         const data = await response.json();

    //         if (!response.ok) {
    //             console.error("Server Error:", data);
    //             alert(`Server Error ${response.status}: ${data.message || JSON.stringify(data)}`);
    //             return;
    //         }

    //         if (data.status) {
    //             alert("Form submitted successfully!");

    //             if (isDownloadPending) {
    //                 const link = document.createElement('a');
    //                 link.href = '/Diamond-Tower-Floor-Plans-Brochure-2.pdf';
    //                 link.download = 'Diamond-Tower-Floor-Plans-Brochure-2.pdf';
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);
    //                 setIsDownloadPending(false);
    //             }

    //             setFormData({ name: "", phone: "" });
    //             setShowPopup(false);
    //         } else {
    //             alert(data.message || "Submission failed. Please try again.");
    //         }

    //     } catch (error) {
    //         console.error("Full Error:", error);
    //         alert(`Error: ${error.message}`);
    //     }
    // };

    //   const handleSubmit = async (e) => {
    //     if (e) e.preventDefault();

    //     // popup form only needs name + phone
    //     if (!formData.name || !formData.phone) {
    //         alert("Please enter name and phone number");
    //         return;
    //     }

    //     try {
    //         const response = await fetch(`${BASE_URL}/ready`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Accept": "application/json"
    //             },
    //             body: JSON.stringify({
    //                 name: formData.name,
    //                 phone: formData.phone,
    //                 email: formData.email || "",
    //                 budget: formData.budget || ""
    //             })
    //         });

    //         const data = await response.json();

    //         if (response.ok) {
    //             alert("Form submitted successfully!");

    //             setFormData({
    //                 name: "",
    //                 email: "",
    //                 phone: "",
    //                 budget: ""
    //             });

    //             setShowPopup(false);
    //         } else {
    //             alert(data.message || "Submission failed.");
    //         }

    //     } catch (error) {
    //         console.error(error);
    //         alert("Something went wrong. Please try again.");
    //     }
    // };


    return (
        <div className="modular-app">
            {/* Navbar section */}
            <nav className="navbar">
                <div className="container nav-content">
                    <div className="logo">
                        <img src={logo} alt="logo" />
                    </div>

                    <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
                    </button>

                    <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#projects">Projects</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#sustainability">Sustainability</a></li>
                    </ul>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="hero" id="home">
                <div className="hero-bg">
                    <img src={heroImg} alt="Modern modular building at dusk" />
                </div>
                <div className="container hero-content reveal reveal-up">
                    <h1>Own a Premium Commercial Office in Hyderabad’s Iconic High-Rise @Financial District</h1>
                    <p>Fully Furnished | Starting ₹42 Lakhs | High Rental Potential | Limited Inventory</p>
                    <button
                        className="btn-primary hero-btn"
                        onClick={handleDownloadClick}
                    >
                        Download Investment Deck<span className="arrow">↗</span>
                    </button>
                </div>
            </section>

            {/* Main Content Areas */}
            <main>
                {/* Stats Section */}
                <div className="container">
                    <section className="stats-section reveal reveal-up">

                        <div className="stat-card reveal reveal-up delay-1">
                            <div className="stat-icon-wrapper animate-float">
                                <i className="fa-solid fa-indian-rupee-sign stat-icon" style={{ width: "100px" }}></i>
                            </div>
                            <h2>42 <br />Lakh</h2>
                            <p>Premium Office Ownership Starting Price</p>
                        </div>

                        <div className="stat-card reveal reveal-up delay-2">
                            <div className="stat-icon-wrapper animate-float">
                                <i className="fa-solid fa-chart-line stat-icon"></i>
                            </div>
                            <h2>Assured <br />Returns</h2>
                            <p>Stable Monthly Rental Income</p>
                        </div>

                        <div className="stat-card reveal reveal-up delay-3">
                            <div className="stat-icon-wrapper animate-float">
                                <i className="fa-solid fa-file-contract stat-icon"></i>
                            </div>
                            <h2>9-Year Lease Security</h2>
                            <p>Long-Term Managed Leasing</p>
                        </div>

                        <div className="stat-card reveal reveal-up delay-4">
                            <div className="stat-icon-wrapper animate-float">
                                <i className="fa-solid fa-shield-halved stat-icon"></i>
                            </div>
                            <h2>Zero Management Hassle</h2>
                            <p>Fully Managed <br />Investment</p>
                        </div>

                    </section>
                </div>

                {/* Features Section */}
                <section className="features-section container" id="services">
                    <div className="feature-row">
                        <div className="feature-text reveal reveal-left">
                            <span className="section-subtitle">THE PROCESS</span>
                            <h2>Why Smart Investors Are Choosing This ?</h2>
                            <div className="to">
                                <ul className="investment-list">
                                    <li>Price lower than current market value</li>
                                    <li>Premium commercial office Iconic tower</li>
                                    <li>Regular monthly rental income</li>
                                    <li>Located in a fast-growing area with high appreciation</li>
                                </ul>

                                <p className="investment-desc">
                                    R1 Commercial converts real estate ownership into predictable monthly income.
                                </p>
                            </div>

                            <button className="btn-primary" onClick={() => setShowPopup(true)}>
                                Our Process <span className="arrow">→</span>
                            </button>
                        </div>
                        <div className="feature-image-group reveal reveal-right">
                            <div className="img-container">
                                <img src={bathroomImg} alt="Bathroom Pod" className="feature-img" />
                            </div>
                            <div className="img-container img-offset">
                                <img src={workerImg} alt="Worker assembling" className="feature-img" />
                            </div>
                        </div>
                    </div>

                    <div className="feature-row reverse" id="projects">
                        <div className="feature-text reveal reveal-right">
                            <span className="section-subtitle">Landmark</span>
                            <h2>R-One Diamond Towers is a premium mixed-use commercial destination built for corporates and global enterprises.</h2>
                            <p>More than just an office project, it is a complete institutional business ecosystem designed for scale, growth, and long-term value.</p>
                            <button className="btn-primary" onClick={() => setShowPopup(true)}>
                                Learn More<span className="arrow">→</span>
                            </button>
                        </div>
                        <div className="feature-image-group single-img-group reveal reveal-left">
                            <div className="img-container block-img">
                                <img src={hospitalImg} alt="Completed exterior" className="feature-img" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Challenges Section */}
                <section className="challenges-section container">
                    <div className="challenges-content reveal reveal-up">
                        <div className="challenges-text">
                            <span className="section-subtitle">Investment Highlights</span>
                            <h2>Investment, income, and growth at a glance.</h2>
                        </div>
                        <div className="challenges-desc">
                            <p>Unlock a 9% Annual Yield with Premium Commercial Real Estate</p>
                        </div>
                    </div>

                    <div className="challenges-grid">
                        <div className="challenge-img-container reveal reveal-left">
                            <img src={financeImg} alt="Healthcare building" className="challenge-img" />
                        </div>
                        <div className="challenge-list reveal reveal-right">
                            <div className="challenge-item">
                                <h3>Investment:</h3>
                                <span className="value">₹42 Lakhs</span>
                            </div>
                            <div className="challenge-item">
                                <h3>Asset:</h3>
                                <span className="value">250 sq ft Managed Office Space</span>
                            </div>
                            <div className="challenge-item">
                                <h3>Passive Income: </h3>
                                <span className="value">₹25,000/month (₹3 Lakhs annually)</span>
                            </div>
                            <div className="challenge-item">
                                <h3>High Upside:</h3>
                                <span className="value">Rent escalation of 15% for every 3 years</span>
                            </div>
                            <div className="challenge-item">
                                <h3>Zero Hassle:</h3>
                                <span className="value">9-Year Fully Managed Lease</span>
                            </div>

                            {/* <div className="challenge-item">
                                <h3>Rental Growth</h3>
                                <span className="value">+15% Every 3 Years</span>
                            </div> */}
                            <div className="investment-message">
                                <h3>Sit back and let your investment work for you!</h3>
                            </div>
                        </div>

                    </div>
                </section>

                {/* Demand Engine Section */}
                <section className="location-section" id="location">
                    <div className="container">
                        <div className="location-grid">

                            <div className="location-image reveal reveal-left">
                                <img src={locationImg} alt="Hyderabad Financial District" />
                                <div className="location-badge animate-pulse-soft">Hyderabad Financial District</div>
                            </div>

                            <div className="location-content reveal reveal-right">
                                <span className="section-subtitle">Demand Engine:</span>
                                <h2 className="location-title">Hyderabad Financial District</h2>
                                <p className="location-intro">
                                    Where companies grow → office demand follows → rentals sustain.
                                </p>

                                <div className="location-highlights">

                                    <div className="highlight-item reveal reveal-up delay-1">
                                        <div className="highlight-icon">
                                            <FaMapMarkerAlt />
                                        </div>
                                        <div className="highlight-text">
                                            <h4>Minutes from Gachibowli IT Hub</h4>
                                            <p>Seamless connectivity to the heart of Telangana's tech revolution.</p>
                                        </div>
                                    </div>

                                    <div className="highlight-item reveal reveal-up delay-2">
                                        <div className="highlight-icon">
                                            <FaRocket />
                                        </div>
                                        <div className="highlight-text">
                                            <h4>HITEC City Proximity</h4>
                                            <p>Close enough to the action, far enough for exclusivity.</p>
                                        </div>
                                    </div>

                                    <div className="highlight-item reveal reveal-up delay-3">
                                        <div className="highlight-icon">
                                            <FaLaptopCode />
                                        </div>
                                        <div className="highlight-text">
                                            <h4>Global Tech Campuses</h4>
                                            <p>Surrounded by Fortune 500 giants and innovation centers.</p>
                                        </div>
                                    </div>

                                    <div className="highlight-item reveal reveal-up delay-4">
                                        <div className="highlight-icon">
                                            <FaRoad />
                                        </div>
                                        <div className="highlight-text">
                                            <h4>ORR Connectivity</h4>
                                            <p>Direct access to the Outer Ring Road for city-wide mobility.</p>
                                        </div>
                                    </div>

                                    <div className="highlight-item reveal reveal-up delay-1">
                                        <div className="highlight-icon">
                                            <FaPlaneDeparture />
                                        </div>
                                        <div className="highlight-text">
                                            <h4>International Airport Access</h4>
                                            <p>Quick transit to Rajiv Gandhi International Airport.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>



                {/* Sustainability Section */}
                <section className="sustainability-section container" id="sustainability">

                    <div className="sustain-header reveal reveal-up">
                        <div className="sustain-title">
                            <span className="section-subtitle">Built for a Sustainable Future</span>
                            <h2>Planet • People • Performance</h2>
                        </div>

                        <div className="sustain-desc">
                            <p>
                                Our advanced off-site construction technology reduces waste, lowers environmental impact, and delivers faster, smarter,
                                and more efficient buildings compared to traditional construction methods.
                            </p>
                        </div>
                    </div>

                    <div className="sustain-cards">

                        <div className="sustain-card reveal reveal-scale delay-1">
                            <div className="sustain-icon animate-float">
                                <FaBuilding />
                            </div>
                            <h3>Select Your Unit</h3>
                            <p>Choose your preferred managed commercial office.</p>
                        </div>

                        <div className="sustain-card reveal reveal-scale delay-2">
                            <div className="sustain-icon animate-float">
                                <FaHandHoldingUsd />
                            </div>
                            <h3>Reserve Your Investment</h3>
                            <p>Secure your unit with a booking amount.</p>
                        </div>

                        <div className="sustain-card reveal reveal-scale delay-3">
                            <div className="sustain-icon animate-float">
                                <FaCreditCard />
                            </div>
                            <h3>Complete the Investment</h3>
                            <p>Finalize payment to activate rental eligibility.</p>
                        </div>

                        <div className="sustain-card reveal reveal-scale delay-4">
                            <div className="sustain-icon animate-float">
                                <FaChartLine />
                            </div>
                            <h3>Start Earning Income</h3>
                            <p>Managed leasing begins and monthly rentals start.</p>
                        </div>

                    </div>

                </section>

                {/* Bottom CTA */}
                <section className="cta-section reveal reveal-scale">
                    <div className="cta-bg">
                        <video autoPlay muted loop playsInline>
                            <source src={craneVideo} type="video/mp4" />
                        </video>

                        <div className="cta-overlay"></div>
                    </div>
                    <div className="cta-content container">
                        <h2>Start Your Next Project the Smart Way</h2>
                        <p>Connect with our experts to transform your next development into a high-performance success.</p>
                        <button className="btn-primary" onClick={() => setShowPopup(true)}>
                            Get in Touch<span className="arrow">→</span>
                        </button>
                    </div>
                </section>


                {/* Secure Room */}
                <section className="secure-room reveal reveal-up">
                    <div className="container">
                        <h2 className="black-head">WHY INVESTORS ARE MOVING FAST</h2>
                        <p className="subhead">
                            Built for Passive Investors
                        </p>
                        <div className="cta-points">
                            <div className="reveal reveal-up delay-1">Builder handles leasing</div>
                            <div className="reveal reveal-up delay-2">Professional management included</div>
                            <div className="reveal reveal-up delay-3">No tenant search required</div>
                            <div className="reveal reveal-up delay-4">Zero operational hassle</div>
                            <div className="reveal reveal-up delay-1">Predictable rental structure</div>
                        </div>
                        <div className="text-center mt-5">
                            <button
                                className="btn-primary hero-btn"
                                onClick={handleDownloadClick}
                            >
                                Download Brochure<span className="arrow">↗</span>
                            </button>
                        </div>
                    </div>
                </section>


                {/* popup */}
                {showPopup && (
                    <div className="popup-overlay" onClick={() => setShowPopup(false)}>

                        <div className="popup-container small-form" onClick={(e) => e.stopPropagation()}>

                            <button className="popup-close" onClick={() => setShowPopup(false)}>✕</button>

                            <div className="otp-form-container">
                                <div className="otp-form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        className="otp-input"
                                    />
                                </div>

                                <div className="otp-form-group flex-row">
                                    <div className="country-code-select">
                                        <span>+91</span>
                                        <span className="arrow-down">⌄</span>
                                    </div>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Your Phone number*"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        className="otp-input flex-1"
                                    />
                                </div>

                                <label className="custom-checkbox-container">
                                    <input type="checkbox" defaultChecked />
                                    <span className="custom-checkmark"></span>
                                    <span className="checkbox-label-text">
                                        I agree to receive newsletters or relevant marketing content and
                                        <a href="#"> r1propturtle&apos;s Terms and Conditions</a>
                                    </span>
                                </label>

                                <button className="otp-submit-btn" onClick={handlePopup}>
                                    {isDownloadPending ? "Download Now" : "Submit"}
                                </button>
                            </div>

                        </div>

                    </div>
                )}


                {/* Premium Contact Section */}
                <section className="premium-contact-section" id="contact">
                    <div className="container">
                        <div className="premium-contact-grid">

                            <div className="premium-contact-image-wrapper">
                                <img
                                    src={formImg}
                                    alt="Hyderabad Financial District"
                                    className="contact-premium-img"
                                />
                                <div className="location-tag">
                                    <span>PRIME LOCATION</span>
                                </div>
                            </div>

                            <div className="premium-contact-form-side">

                                <div className="form-header">
                                    <span className="form-subtitle">READY TO INVEST?</span>
                                    <h2>Get Expert Real Estate Advice</h2>
                                    <p>
                                        Join 500+ institutional investors today.

                                    </p>
                                </div>

                                <div className="premium-form-container">

                                    <div className="premium-field-full">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter your name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="premium-field-row">
                                        <div className="premium-field">
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder=""
                                                value={formData.email}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="premium-field">
                                            <label>Phone Number</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                placeholder=""
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="premium-field-full">
                                        <label>Expected Investment Budget</label>
                                        <select
                                            name="budget"
                                            value={formData.budget}
                                            onChange={handleInputChange}
                                        >
                                            <option value="" disabled>Select Range</option>
                                            <option value="42L">₹42L</option>
                                            <option value="1CR">₹1CR</option>
                                            <option value="1CR-3CR">₹1CR-₹3CR</option>
                                        </select>
                                    </div>

                                    <button
                                        className="premium-callback-btn"
                                        onClick={handleSubmit}
                                    >
                                        Request Callback <span className="arrow-right">→</span>
                                    </button>

                                </div>

                            </div>

                        </div>
                    </div>
                </section>



                {/* Premium Urgency Section */}
                <section className="premium-urgency-section" id="urgency">
                    <div className="container">
                        <div className="urgency-premium-wrapper reveal reveal-scale" style={{ backgroundImage: `url(${urgencyBg})` }}>
                            <div className="urgency-overlay"></div>
                            <div className="urgency-content">
                                <div className="scarcity-badge-wrapper reveal reveal-up delay-1">
                                    <span className="scarcity-badge animate-pulse-soft">Commercial Units Are Limited.</span>
                                </div>
                                <h2 className="premium-urgency-title reveal reveal-up delay-2">Institutional Leasing Floor <br /><span>Filling Fast</span></h2>
                                <p className="premium-urgency-desc reveal reveal-up delay-3">Join the few who have already secured their passive income slots for the year.</p>

                                <div className="premium-urgency-benefits">
                                    <div className="premium-benefit-pill reveal reveal-up delay-1">
                                        <span className="check-icon">✓</span> Lower Entry Pricing
                                    </div>
                                    <div className="premium-benefit-pill reveal reveal-up delay-2">
                                        <span className="check-icon">✓</span> Early Allocation Advantage
                                    </div>
                                    <div className="premium-benefit-pill reveal reveal-up delay-3">
                                        <span className="check-icon">✓</span> Guaranteed Managed Income
                                    </div>
                                </div>

                                <button className="premium-register-btn animate-pulse-soft" onClick={() => window.location.href = '#contact'}>
                                    Register Your Interest Now
                                </button>
                            </div>
                        </div>
                    </div>
                </section>




                {/*  */}


            </main>

            {/* Premium Site Footer */}
            <footer className="site-footer-premium">
                <div className="container">
                    <div className="footer-premium">

                        <div className="footer-container">

                            {/* <img src={logo2} alt="R-One Logo" className="footer-main-logo"/> */}

                            <h3 className="footer-title">
                                Turn Commercial Real Estate Into Monthly Cash Flow
                            </h3>

                            <p className="footer-subtitle">
                                Own. Lease. Earn. Repeat.
                            </p>

                            <div className="footer-divider"></div>

                            {/* <div className="footer-powered">
      <span>Powered by</span>
      <img src={white} alt="PropTurtle Logo"/>
    </div> */}

                            <p className="footer-text">
                                Developed By <img src={logo2} alt="R-One Group Logo" className="dev-logo" />
                            </p>

                            <p className="footer-text">
                                <img src={white} alt="PropTurtle Logo" className="partner-logo" />
                                Strategic Marketing Partner
                            </p>

                            <div className="footer-divider"></div>

                            <p className="footer-text">
                                📍 Project Location: Financial District, Hyderabad
                            </p>

                            <p className="footer-contact">
                                📞 For Investor Enquiries
                                <strong>+91 9000203636</strong>
                            </p>

                            <p className="footer-copy">
                                © 2026 All Rights Reserved
                            </p>

                        </div>

                    </div>

                    {/* <div className="footer-legal-links">
                            <a href="#">Privacy Policy</a>
                            <a href="#">Terms & Conditions</a>
                            <a href="#">Sitemap</a>
                        </div> */}
                </div>

            </footer>
        </div>
    );
}
